<template>
<div v-if="status.requestInProgress">
	<v-dialog
	v-model="visible"
	width="300px"
	hide-overlay
	>
		<v-card
			color="primary"
			dark
		>
			<v-card-text>
			<template>
				In progress …
			</template>
			<v-progress-linear
				indeterminate
				color="white"
				class="mb-0"
			></v-progress-linear>
			</v-card-text>
		</v-card>

	</v-dialog>
</div>
<div v-else>
	<v-dialog v-model="visible" persistent max-width="800px">
		<v-card>
			<v-card-title class="headline">
				<div>
					Share token <span class="teal--text">{{metadata.name}}</span>
				</div>
			</v-card-title>
			
			<v-expansion-panel v-model="current_item">
				<v-expansion-panel-content v-for="(item, i) in items" :key="i">
					<template v-if="i > 0">
						<v-container fluid slot="header">
						
							<v-layout v-if="item.user_id != '00000000'" row wrap>
								<v-flex xs12 md4>
									<v-chip
									label
									color="info"
									text-color="white"
									class="mr-3"
									style="min-width:16ex">{{item.handle}}</v-chip>
								</v-flex>
								
								<v-flex xs12 md4>
									<v-chip v-if="item.permissions.includes('r')"
									small outline color="success"
									>Read</v-chip>
									<v-chip v-if="item.permissions.includes('c')"
									small outline color="error lighten-2"
									>Write</v-chip>
									<v-chip v-if="item.permissions.includes('s')"
									small outline color="primary"
									>Share</v-chip>
								</v-flex>
								
								<v-flex v-if="item.expiry" xs12 md4>
									<v-icon flat small>fa-calendar</v-icon>
									{{item.expiry |date}}
								</v-flex>
								
							</v-layout>
							<v-layout v-else row wrap>
							
								<v-flex xs12 md4>
									<v-chip
									label
									color="teal"
									text-color="white"
									style="min-width:16ex">Public</v-chip>
								</v-flex>
								
								<v-flex xs12 md4>
									<v-chip v-if="item.permissions.includes('s')"
									small outline color="warning darken-2"
									>Shown on main page</v-chip>
								</v-flex>
								
								<v-flex v-if="item.expiry" xs12 md4>
									<v-icon flat small>fa-calendar</v-icon>
									{{item.expiry |date}}
								</v-flex>
								
							</v-layout>
						</v-container>
						
						<v-card>
							<v-card-actions>
							
								<v-text-field :ref="'channel_url_'+item.v_token_id"
								label="Channel URL"
								hint="Copy this URL by clicking on the icon"
								persistent-hint
								append-icon="fa-copy"
								:append-icon-cb="copyText(item.v_token_id)"
								:value="urlFor(item.v_token_id)"
								read-only
								/>
							
								<v-spacer/>
								<v-btn flat color="error"
								@click="() => confirmUnshare(item)">
									<v-icon left>fa-trash</v-icon>
									Unshare
								</v-btn>
							</v-card-actions>
						</v-card>
					</template>
					<template v-else>
						<v-container fluid slot="header">
							<v-layout row wrap>
								<v-flex xs12>
									<v-chip
									label
									style="min-width:16ex">New share</v-chip>
								</v-flex>
							</v-layout>
						</v-container>
						<follow-token-share-form v-if="i == current_item"
						:item="item"
						v-on:shared="refreshShares"/>
					</template>
				</v-expansion-panel-content>
			</v-expansion-panel>
			
			<v-card-actions>
				<v-btn flat @click="dismiss">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Vuex from 'vuex'
import * as moment from 'moment'
import api from '../../assets/js/api-instance'
import FollowTokenShareForm from '../partials/TokenShareForm'

export default {
	name: "FollowTokenShare",
	
	components: { FollowTokenShareForm },
	
	props: ["show"],

	data () {
		return {
			current_item: 0,
			token_id: null,
			metadata: {},
			shares: [],
			status: {}
		};
	},
	
	watch: {
		show () {
			if (this.show instanceof Object) {
				this.setData(this.show);
			} else if (typeof this.show == 'string') {
				const token = this.$store.state.tokenData.tokens.find(t => t.token_id == this.show);
				this.setData(token);
				if (!token) {
					console.warn("Token editor: received token ID but cannot find this token", this.show);
				}
			} else {
				this.reset();
			}
		}
	},
	
	computed: {
		visible: {
			get () {
				return !!this.show;
			},
			set () {
				this.$emit('hide')
			}
		},
		
		items () {
			return [ {
				r_token_id: this.token_id,
				user_id: null,
				permissions: "",
				expiry: null
			}, ... this.shares];
		}
	},
	
	filters: {
		date (value, format = "YYYY-MM-DD") {
			return moment(value).format(format);
		}
	},

	methods: {
		async setData (obj) {
			this.token_id = obj.token_id;
			this.metadata = obj.metadata || {};
			
			this.refreshShares()
		},
		
		reset () {
			this.token_id = null;
			this.metadata = {};
			this.shares = [];
		},
		
		async refreshShares () {
			this.shares = await api.listTokenShares(this.token_id);
			this.current_item = null;
		},
		
		urlFor (v_token_id) {
			return document.location.origin+'/#/tokens/'+v_token_id;
		},
		
		copyText(v_token_id) {
			return () => {
				const ref = "channel_url_" + v_token_id;
				const element = this.$refs[ref][0].$el.querySelector("input");
				element.focus();
				element.select();
				document.execCommand('copy');
				this.$root.$emit('snackbar', {message: "URL copied to clipboard"});
			}
		},
		
		async unshare (token) {
			try {
				await api.removeToken(token.v_token_id);
				this.refreshShares();
			} catch (err) {
				console.warn("Error removing share", err);
			}
		},
		
		confirmUnshare (token) {
			if (token) {
				this.$root.$emit('dialogue', {
					confirmYesNo: {
						title: `Unshare ‘${token.metadata && token.metadata.name || token.v_token_id}’ from ${token.user_id == '00000000' ? 'the public' : token.handle}`,
						text: "Are you sure you want to <b>permanently</b> remove this share? This action cannot be undone.",
						textYes: "Unshare",
						textNo: "Keep",
						actionYes: () => this.unshare(token)
					}
				});
			}
		},
		
		async dismiss () {
			this.reset();
			this.$emit("hide");
		}

	}

}
</script>
